/* eslint-disable no-undef */
export default function () {
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container">
        <div class="swiper-wrapper">
        </div>
    </div>
  `;

  // Slide Template
  function buildSlideTemplate(slide, pagination) {
    const title = `<h2>${
      slide.Title.length > 50
        ? ` ${slide.Title.substring(0, 50)}...`
        : slide.Title
    }</h2>`;

    const buttons = function (btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');

        if (btn1) {
          btnContainer.append(`<a href="${btn1}" class="button">More</a>`);
        }
        if (btn2) {
          btnContainer.append(
            `<a href="${btn2}" class="button">${btn2Text}</a>`
          );
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };

    const template = `
    <div class="swiper-slide">
      <div class="swiper-image-container swiper-lazy" data-background="${
        slide.ImageWithPath
      }"
        aria-label="${slide.ImageAlternateText}">
        <div class="swiper-lazy-preloader"></div>
      </div>
      <div class="swiper-content-container">
        <div class="container">
         
          <div class="swiper-content-text">
            ${title}
          </div>
          ${buttons(
            slide.URL,
            slide.DetailLinkText,
            slide.PurchaseURL,
            slide.PurchaseLinkText
          )}
          
          ${
            pagination
              ? `<div class="swiper-positions">
            
             <div class="swiper-arrows__button swiper-arrows__button--prev" tabindex="0" role="button"
              aria-label="Previous slide">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15">
                  <path class="cls-1" d="M2396,996c0,0.4,9,8,9,8v-5h8s1.12-2.189,1-3a6.136,6.136,0,0,0-1-2h-8v-5S2396,995.6,2396,996Z" transform="translate(-2396 -989)"/>
                </svg>

              </span>
            </div>

            <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>

            <div class="swiper-arrows__button swiper-arrows__button--next" tabindex="0" role="button" aria-label="Next slide">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15">
                  <path class="cls-1" d="M2561,994h8v-5l9,7-9,8v-5h-8a2.76,2.76,0,0,1-1-2A8.021,8.021,0,0,1,2561,994Z" transform="translate(-2560 -989)"/>
                </svg>
              </span>
            </div>

          </div>`
              : ''
          }
          
          
        </div>
        
      </div>
    </div>
  `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);
    const pagination = widgetData.length > 1;
    widgetData.forEach((slide) => {
      swiperWidgetWrapper.append(buildSlideTemplate(slide, pagination));
    });

    function autoPlaySettings() {
      if (widgetData.length > 1) {
        return { delay: 8000 }; // this line enable the autoplay and timing
      }
      return false;
    }

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        nextEl: '.swiper-arrows__button--next',
        prevEl: '.swiper-arrows__button--prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: autoPlaySettings(),
      allowSlideNext: autoPlaySettings(),
      allowSlidePrev: autoPlaySettings(),
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then((response) => {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      if (window.innerWidth < 768) {
        $(`#${widgetName}`).parent().next().css('padding-top', '25vw');
      } else {
        $(`#${widgetName}`).parent().next().css('padding-top', '100px');
      }
      $(`#${widgetName}`).remove();
    }
  });
}
